export const TimezoneInitialValues = {
  selectTimeZone: null,
};
